import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { CoreService } from "../../../../../../../shared/src/lib/services/core.service";
import { MatDialog } from "@angular/material/dialog";
import { navItems } from "../../vertical/sidebar/sidebar-data";
import { TranslateService } from "@ngx-translate/core";
import { Router, RouterModule } from "@angular/router";
import { TablerIconsModule } from "angular-tabler-icons";
import { BrandingComponent } from "../../vertical/sidebar/branding.component";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FeatherModule } from "angular-feather";
import { MaterialModule } from "../../../../material.module";
import { ApiService } from "../../../../../../../shared/src/lib/services/api.service";
import { NgScrollbarModule } from "ngx-scrollbar";
import { DecimalPipe, NgIf } from "@angular/common";
import { EventService } from "../../../../../../../shared/src/lib/services/event.service";
import { FeatureFlagService } from "../../../../../../../shared/src/lib/services/feature-flag.service";

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

const dropdownItems = [
  { title: "My Profile", subTitle: "Accounts Settings", path: "/home/my-account", icon: "person" },
  { title: "Exchange Rate", subTitle: "", path: "/configuration/exchange-rate", icon: "credit_card", permission: "canConfigureCurrency" },
  { title: "Roles", subTitle: "", path: "/settings/roles", icon: "shield_person", permission: "canManageRoles" },
  { title: "Services Config", subTitle: "", path: "/home/services-config", icon: "settings_applications", permission: "canConfigureSystemConfigs" },
  { title: "Feature Flags", subTitle: "", path: "/configuration/feature-flags", icon: "flag", permission: "canManageFeatureFlags", flag: "enableFeatureFlag" },
  { title: "BM Fancy Config", subTitle: "", path: "/home/bm-fancy-config", icon: "tune", permission: "canConfigureBookmakerFancy" },
  { title: "Change Password", subTitle: "", path: "/home/reset-password", icon: "lock" },
];

@Component({
  selector: "app-horizontal-header",
  standalone: true,
  imports: [RouterModule, TablerIconsModule, MaterialModule, BrandingComponent, FeatherModule, NgScrollbarModule, ReactiveFormsModule, NgIf, DecimalPipe],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
})
export class AppHorizontalHeaderComponent implements OnInit {
  featureFlagService = inject(FeatureFlagService);
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;
  userData = { NAME: "", BALANCE: 0, ROLE_NAME: "" };
  searchParam = new FormControl("");
  uData: any;

  public selectedLanguage: any = {
    language: "English",
    code: "en",
    type: "US",
    icon: "/assets/images/flag/icon-flag-en.svg",
  };

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private apiService: ApiService,
    private router: Router,
    private eventService: EventService,
  ) {
    translate.setDefaultLang("en");

    this.searchParam.valueChanges.subscribe((value) => {
      if (!value) {
        this.eventService.searchEvent.emit(value);
      }
    });

    this.eventService.updateEvent.subscribe((value) => {
      if (value) {
        this.getUserDetails(this.uData.ID);
      }
    });
  }

  ngOnInit(): void {
    let uData = this.apiService.getUserData();
    this.uData = uData;
    this.getUserDetails(uData.ID);
  }

  showDropdownItem(item: any): boolean {
    const permissionOk = !item.permission || this.apiService.permissions.includes(item.permission);
    const flagOk = !item.flag || this.featureFlagService.getFeature(item.flag);

    return permissionOk && flagOk;
  }

  get isSearchPage() {
    return this.router.url === "/home/users";
  }

  activateSearch() {
    this.eventService.searchEvent.emit(this.searchParam.value);
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  getUserData() {
    return this.apiService.getUserData();
  }

  getUserDetails(id: string) {
    let resp = this.apiService.send2ServerRelative(`users/get/${id}`);
    resp.subscribe((data) => {
      if (data.status == "ok") {
        this.userData = data.result[0];
      }
    });
  }

  logOut() {
    this.apiService.clearUserToken();
    this.router.navigate(["/authentication/login"]);
  }

  profiledd: profiledd[] = [
    {
      id: 1,
      img: "/assets/images/svgs/icon-account.svg",
      title: "My Profile",
      subtitle: "Account Settings",
      link: "/",
    },
  ];
  protected readonly dropdownItems = dropdownItems;
}

@Component({
  selector: "app-search-dialog",
  standalone: true,
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: "search-dialog.component.html",
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = "";
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
